<div class="input-group me-3" [ngClass]="inputGroupClasses">
    <div class="input-group-text">
        <wdx-icon icon="search"></wdx-icon>
    </div>
    <input
        #searchInput
        class="form-control"
        type="search"
        inputmode="search"
        [placeholder]="placeholder | translateTokenisedString"
        (search)="$event.stopPropagation()"
        [(ngModel)]="value"
        (ngModelChange)="search($event)"
        data-cy="search-input"
    />
</div>
